<template>

    <!-- title="多原料修改" -->
  <a-drawer
    :visible="visible"
    class="custom-class"
    placement="right"
    width="1000"
    @close="cancel"
    :maskClosable="false"
    destroyOnClose
  >
    <div style="position: relative;display: flex;margin-bottom: 20px;">
      <h3 style="font-weight: bold;margin-right: 20px;">多原料修改</h3>
      <a-steps :current="steps" size="small" style="width: 500px;">
        <a-step title="选择指标" />
        <a-step title="修改数值" />
        <a-step title="修改并保存" />
      </a-steps>
    </div>
    <mater-drawer-select v-if="steps === 0" />
    <mater-drawer-edit v-if="steps === 1" />
  </a-drawer>
</template>
<script>
import MaterDrawerSelect from './MaterDrawerSelect.vue'
import MaterDrawerEdit from './MaterDrawerEdit.vue'
import { mapState,mapMutations } from 'vuex'
export default {
  components:{
    MaterDrawerSelect,
    MaterDrawerEdit
  },
  data(){
    return {
      // steps: 0,
      // visible:false
    }
  },
  computed:{
    ...mapState('material',['steps','visible'])
  },
  methods:{
    ...mapMutations('material',['setState']),
    modalShow(){
      this.setState({visible: true})
    },
    cancel(){
      this.setState({steps: 0,codeArr:[],selectedList:[],selectedRowKeys:[],marterArr:[],visible: false})
    }
  }
}
</script>

<style lang="scss">
.custom-class{
  .footer{
    .count{
      float: left;
      margin-left: 10px;
    }
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: right;
    .ant-btn{
      margin-right: 20px;
    }
  }
}
</style>
